// A small "pet" affordance shown next to a pet's name, so a wish owned by a pet
// reads as distinct from one owned by a person. Shows a paw print plus the
// species when we know it (e.g. "🐾 Dog"), or just "🐾 Pet" otherwise.
export default function PetBadge({ species, className = '' }) {
    return (
        <span
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-semibold bg-amber-100 text-amber-700 align-middle ${className}`}
        >
            <span aria-hidden="true">🐾</span>
            {species || 'Pet'}
        </span>
    );
}
